import { axios, getConfigs, IRequestConfig, ModalityEnum } from './api'

export interface ExamMinDTO {
  id: number
  code: string
  label: string
  siteId: number
  modality: ModalityEnum
}

export interface MemberPreferencesDto {
  memberId: number
  favoriteExams: ExamMinDTO[]
}

export class MemberPreferencesService {
  private static readonly endpoint = 'member-preferences'

  static getMemberPreferences(): Promise<MemberPreferencesDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        this.endpoint,
        {},
      )
      axios(configs, resolve, reject)
    })
  }
}
